import { render, staticRenderFns } from "./invCode.vue?vue&type=template&id=0190bccc&"
import script from "./invCode.vue?vue&type=script&lang=js&"
export * from "./invCode.vue?vue&type=script&lang=js&"
import style0 from "./invCode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports